/**
 * Utility functions for timecard calculations
 */

export const calculateHoursWorked = (
  startTime: string | null,
  endTime: string | null,
  mealStart: string | null,
  mealEnd: string | null,
): number => {
  if (!startTime || !endTime) return 0;

  const start = new Date(startTime).getTime();
  const end = new Date(endTime).getTime();
  let totalMs = end - start;

  // Subtract meal time if both meal times exist
  if (mealStart && mealEnd) {
    const mealStartMs = new Date(mealStart).getTime();
    const mealEndMs = new Date(mealEnd).getTime();
    totalMs -= mealEndMs - mealStartMs;
  }

  return Math.max(0, totalMs / (1000 * 60 * 60)); // Convert to hours
};
